import { Button, useNotify, useRefresh } from "react-admin";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import { candidateRequests } from "api/candidateApi";
import dataProvider from "server/dataProvider";

const ChangePaidEducationModal = ({ record }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleConfirm = async () => {
    await dataProvider.customRequest(
      candidateRequests.updateCandidacyPaidEducation(record?.id),
      { onlyPaidEducation: !record.onlyPaidEducation },
      "PUT",
    );
    refresh();
    notify("Успешно сменен статус", { type: "success" });
  };

  return (
    <ConfirmModal
      btnStyle={{ width: "max-content", height: "min-content" }}
      titleContent="Смени статус"
      message={'Сигурен ли сте, че искате да смените статуса на "Кандидатства за платено обучение" ?'}
      onConfirm={handleConfirm}
      triggerButton={
        <Button
          sx={{ width: "fit-content" }}
          disabled={record?.hasApprovedRanking}
          startIcon={<CurrencyExchangeIcon />}
          variant="contained"
          label="Смени статус"
          size="medium"
        />
      }
    />
  );
};

export default ChangePaidEducationModal;
